const i=i=>{var e,o;return(null===(e=null==i?void 0:i.price)||void 0===e?void 0:e.bestPrice)&&Boolean(Number(null===(o=null==i?void 0:i.price)||void 0===o?void 0:o.discount))?i.price.bestPrice:void 0};export{i as default};
